import { memo } from "react";
import { FormFieldProps } from "./types";
import { Separator } from "@/components/ui/separator";
import CheckboxField from "./CheckboxField";

const SetField = memo(({ config, control, getValues }: FormFieldProps) => {
  return (
    <div className="w-full flex flex-col gap-2 justify-start">
      <b className="text-left text-grey-700 text-sm my-2">{config.label}</b>
      <div className="flex gap-2 flex-wrap">
        {config.subfields?.map((subfield, index) => {
          if (subfield.type === "checkbox") {
            return (
              <CheckboxField
                key={index}
                config={subfield}
                control={control}
                getValues={getValues}
              />
            );
          } else if (subfield.name === "separator") {
            return (
              <Separator key={index} className={`my-4 ${subfield.className}`} />
            );
          }
          return null;
        })}
      </div>
    </div>
  );
});

SetField.displayName = "SetField";
export default SetField;
